import React, { useState, useEffect } from "react";
import { GraphQLClient } from "graphql-request";
import Header from "../Components/header";
import Footer from "../Components/footer";
import { AnimatePresence, motion } from "framer-motion";

const getIndici = async () => {
  const client = new GraphQLClient(
    "https://api-eu-central-1-shared-euc1-02.hygraph.com/v2/clweq2m6a000001w67aqzeh7x/master"
  );

  const query = `
    query GetText {
      indicis(orderBy: anno_DESC) {
        id
        titolo
        anno
        pdf {
          url
        }
        tipoRivista
      }
    }
  `;

  try {
    const data = await client.request(query);
    return data.indicis;
  } catch (error) {
    console.error("Errore nel recupero degli indici:", error);
    return [];
  }
};

const AccordionContext = React.createContext({});
const useAccordion = () => React.useContext(AccordionContext);

const Accordion = ({
  id,
  expanded,
  setExpanded,
  title,
  description,
  indiciByAnno,
}) => {
  const isOpen = id === expanded;

  function formatToTitleCase(str) {
    console.log(str);
    return str
      .replace(/([a-z])([A-Z])/g, "$1 $2") // Aggiunge uno spazio tra la parte minuscola e quella maiuscola
      .replace(/^./, str[0].toUpperCase()); // Rende la prima lettera maiuscola
  }

  return (
    <>
      <motion.div
        initial={false}
        onClick={() => setExpanded(isOpen ? null : id)}
        className="flex justify-between items-center border-b py-2 hover:bg-gray-100 transition"
      >
        <h2 className="font-semibold text-xl">{title}</h2>
      </motion.div>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 1 }}
            transition={{ type: "spring", duration: 0.5, bounce: 0 }}
            className="overflow-hidden"
            style={{
              backgroundColor: "white",
              padding: "0 2rem",
            }}
          >
            {Object.keys(indiciByAnno).map((anno) => (
              <div key={anno} className="mb-6">
                <ul className="space-y-2">
                  {indiciByAnno[anno].map(
                    (indice) =>
                      formatToTitleCase(indice.tipoRivista) === title && (
                        <li
                          key={indice.id}
                          className="flex justify-between items-center border-b py-2 hover:bg-gray-100 transition"
                        >
                          <span>{indice.titolo}</span>
                          <a
                            href={indice.pdf.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:text-blue-800"
                          >
                            Scarica PDF
                          </a>
                        </li>
                      )
                  )}
                </ul>
              </div>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

const Indici = () => {
  const [indici, setIndici] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expanded, setExpanded] = useState(null);

  const tipoRivista = ["Modellistica", "Volo Elettrico"];

  useEffect(() => {
    const fetchIndici = async () => {
      try {
        const indiciData = await getIndici();
        console.log(indiciData);
        setIndici(indiciData);
      } catch (error) {
        setError("Errore nel caricamento dei file PDF.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchIndici();
  }, []);

  // Raggruppa gli indici per anno
  const indiciByAnno = indici.reduce((acc, indice) => {
    const { anno } = indice;
    if (!acc[anno]) acc[anno] = [];
    acc[anno].push(indice);
    return acc;
  }, {});

  const handleDownload = (pdfUrl) => {
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = "file.pdf";
    link.target = "_blank";
    link.click();
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-6">
        <h1 className="text-3xl font-bold text-center mb-6">Indici</h1>

        {isLoading && (
          <p className="text-center text-gray-500 animate-pulse">
            Caricamento...
          </p>
        )}

        {error && <p className="text-center text-red-500">{error}</p>}

        {!isLoading && !error && indici.length === 0 && (
          <p className="text-center text-gray-500">Nessun PDF disponibile.</p>
        )}

        {!isLoading && indici.length > 0 && (
          <div className="max-w-2xl mx-auto">
            {tipoRivista.map((tipo, index) => (
              <div key={index} className="mb-6">
                <ul className="space-y-2">
                  <Accordion
                    key={index}
                    id={index}
                    title={tipo}
                    description={"prova url"}
                    setExpanded={setExpanded}
                    expanded={expanded}
                    indiciByAnno={indiciByAnno}
                  />
                </ul>
              </div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default Indici;
